import React from "react";
import { Badge } from "@/components/ui/badge";
import type { QuoteStatus } from "@/types";

export const QUOTE_STATUS_LABELS: Record<QuoteStatus, string> = {
  DRAFT: "Draft",
  PENDING_APPROVAL: "Pending Approval",
  APPROVED: "Approved",
  SENT: "Sent",
  ACCEPTED: "Accepted",
  REJECTED: "Rejected",
  SUPERSEDED: "Superseded",
};

const VARIANTS: Record<QuoteStatus, "default" | "secondary" | "destructive" | "outline" | "success" | "warning" | "blue"> = {
  DRAFT: "secondary",
  PENDING_APPROVAL: "warning",
  APPROVED: "blue",
  SENT: "default",
  ACCEPTED: "success",
  REJECTED: "destructive",
  SUPERSEDED: "outline",
};

export function QuoteStatusBadge({ status, expired }: { status: QuoteStatus; expired?: boolean }) {
  if (expired) {
    return <Badge variant="destructive">Expired</Badge>;
  }
  return <Badge variant={VARIANTS[status] || "outline"}>{QUOTE_STATUS_LABELS[status] || status}</Badge>;
}
